import reverse from "lodash/reverse.js";
import uniqBy from "lodash/uniqBy.js";
const getUniqueByRoles = (employee) => uniqBy(reverse((employee == null ? void 0 : employee.positions) ?? []), ({ role }) => role);
export {
  getUniqueByRoles
};
